import { ApplicationData } from "../ApplicationData";

export const ThirdPartyDBUtils = (function( $ ) {
	var spacer = ", ";
	var displayNone = 'style="display: none"';
	return {
		getTitleWithLink:          function( data ) {
			if( data.articleInfo && data.articleInfo.title === "" ) {
				data.articleInfo.title = "There is no title";
			}
			if( data.articleInfo && data.articleInfo.title ) {
				var url = ThirdPartyDBUtils.getEbscoPermalinkUrl( data );
				if( url.length > 0 ) {
					return '<a target="_blank" href="' + url + '">' + data.articleInfo.title + '</a>';
				}
				return data.articleInfo.title;
			}
			return "";
		},
		getEbscoAuthor:            function( data ) {
			if( data.articleInfo && data.articleInfo.authors && data.articleInfo.authors.length > 0 && data.pubType != "Author" ) {
				return ApplicationData.language.by + " " + data.articleInfo.authors[0];
			}
			return "";
		},
		getEbscoAuthors:           function( data ) {
			if( data.articleInfo && data.articleInfo.authors && data.articleInfo.authors.length > 0 ) {
				var text = "<ul>";
				$.each( data.articleInfo.authors, function( index, author ) {
					text += '<li><a href="javascript:;" class="searchLink" data-value="' + author + '" data-type="author">' + author + '</a></li>';
				} );
				text += "</ul>";
				return text;
			}
			return "";
		},
		getEbscoSubjects:          function( data ) {
			if( data.articleInfo && data.articleInfo.authors && data.articleInfo.subjects.length > 0 ) {
				var text = "<ul>";
				$.each( data.articleInfo.subjects, function( index, subject ) {
					text += '<li><a href="javascript:;" class="searchLink" data-value="' + subject + '" data-type="subject">' + subject + '</a></li>';
				} );
				text += "</ul>";
				return text;
			}
			return "";
		},
		getEbscoPermalinkUrl:      function( data ) {
			var url = "";
			if( data.externalLinks ) {
				$.each( data.externalLinks, function( index, link ) {
					if( link.type == "persistentLink" ) {
						url = link.url;
						return false;
					}
				} );
				return url;
			}
			return "";
		},
		getEbscoPersistentLink:    function( data ) {
			var url = ThirdPartyDBUtils.getEbscoPermalinkUrl( data );
			if( url.length > 0 ) {
				return '<a target="_blank" href="' + url + '">' + url + '</a>';
			}
			return "";
		},
		getEbscoArticleInfo:       function( data ) {
			var response = "";

			switch( data.pubType ) {
				case "Series":
					response = ThirdPartyDBUtils.buildSeriesInfo( data );
					break;
				case "Author":
					response = ThirdPartyDBUtils.buildAuthorInfo( data );
					break;
				case "Book":
					response = ThirdPartyDBUtils.buildBookInfo( data );
					break;
				case "Review":
					response = ThirdPartyDBUtils.buildReviewInfo( data );
					break;
				case "Periodical":
					response = ThirdPartyDBUtils.buildPeriodicalInfo( data );
					break;
				case "WIRES":
					response = ThirdPartyDBUtils.buildGenericInfo( data );
					break;
				case "NEWSP":
					response = ThirdPartyDBUtils.buildGenericInfo( data );
					break;
				case "TSRPT":
					response = ThirdPartyDBUtils.buildGenericInfo( data );
					break;
				case "Encyclopedia":
					response = ThirdPartyDBUtils.buildEncyclopediaInfo( data );
					break;
				default:
					response = ApplicationData.language.articleRecord;
					break;
			}

			return response;
		},
		buildSeriesInfo:           function( data ) {
			var response = ApplicationData.language.series + " - ";

			if( data.publicationInfo && data.publicationInfo.date ) {
				response += data.publicationInfo.date;
			}

			// TODO: add audience range? - needs to be added to ebsco manager on backend

			return response;
		},
		buildAuthorInfo:           function( data ) {
			return ApplicationData.language.authorRecord;
		},
		buildBookInfo:             function( data ) {
			var response = "";

			if( data.publicationInfo && data.publicationInfo.publisher ) {
				response += data.publicationInfo.publisher;
				response += spacer;
			}
			if( data.publicationInfo && data.publicationInfo.date ) {
				response += data.publicationInfo.date;
			}

			return response;
		},
		buildReviewInfo:           function( data ) {
			if( data.articleInfo && data.articleInfo.docType ) {
				return data.articleInfo.docType;
			}
			return "";
		},
		buildPeriodicalInfo:       function( data ) {
			var response = "";

			if( data.journalInfo && data.journalInfo.title ) {
				response += data.journalInfo.title;
				response += spacer;
			}
			if( data.publicationInfo && data.publicationInfo.date ) {
				response += data.publicationInfo.date;
				response += spacer;
			}
			if( data.publicationInfo && data.publicationInfo.volume ) {
				response += ThirdPartyDBUtils.getEbscoVolume( data );
				response += spacer;
			}
			if( data.publicationInfo && data.publicationInfo.issue ) {
				response += ThirdPartyDBUtils.getEbscoIssue( data );
				response += spacer;
			}
			if( data.articleInfo && data.articleInfo.pageFrom && data.articleInfo.pageCount ) {
				response += ThirdPartyDBUtils.getEbscoPageFromTo( data );
				response += spacer;
			}
			if( data.articleInfo && data.articleInfo.pageCount ) {
				response += ThirdPartyDBUtils.getEbscoPageCount( data );
			}

			return response;
		},
		buildGenericInfo:          function( data ) {
			var response = "";

			if( data.publicationInfo && data.publicationInfo.date ) {
				response += data.publicationInfo.date;
				response += " - ";
			}
			if( data.journalInfo && data.journalInfo.title ) {
				response += data.journalInfo.title;
			}

			return response;
		},
		buildEncyclopediaInfo:     function( data ) {
			var response = "";

			if( data.headerInfo && data.headerInfo.longDbName ) {
				response += data.headerInfo.longDbName;
			}

			return response;
		},
		getEbscoPageFromTo:        function( data ) {
			if( data.articleInfo ) {
				var start = parseInt( data.articleInfo.pageFrom, 10 );
				var count = parseInt( data.articleInfo.pageCount, 10 );
				return  ApplicationData.language.pageAbbreviation + (start) + "-" + (start + count)
			}
			return "";
		},
		getEbscoPageCount:         function( data ) {
			if( data.articleInfo ) {
				var count = parseInt( data.articleInfo.pageCount, 10 );
				return count + ApplicationData.language.pageAbbreviation
			}
			return "";
		},
		getEbscoVolume:            function( data ) {
			if( data.publicationInfo && data.publicationInfo.volume ) {
				return ApplicationData.language.vol + " " + data.publicationInfo.volume + ((data.publicationInfo.issue.length == 0) ? "," : "");
			}
			return "";
		},
		getEbscoIssue:             function( data ) {
			if( data.publicationInfo && data.publicationInfo.issue ) {
				return ApplicationData.language.issue + " " + data.publicationInfo.issue
			}
			return "";
		},
		getBritannicaTitleAndLink: function( data ) {
			if( data.title && data.link ) {
				return '<a target="_blank" href="' + data.link + '">' + data.title + '</a>';
			} else if( data.title ) {
				return data.title;
			}
			return "";
		},
		getBritannicaDescription:  function( data ) {
			if( data.description ) {
				return data.description;
			}
			return "";
		},
		getNewsbankTitleAndLink:   function( data ) {
			if( data.title && data.persistentLink ) {
				return '<a target="_blank" href="' + data.persistentLink + '">' + data.title + '</a>';
			} else if( data.title ) {
				return data.title;
			}
			return "";
		},
		getNewsbankAuthor:         function( data ) {
			if( data.author ) {
				return data.author;
			}
			return "";
		},
		getNewsbankSource:         function( data ) {
			if( data.source && data.length ) {
				return data.source + " - " + data.length;
			} else if( data.source ) {
				return data.source;
			}
			return "";
		},
		getNewsbankSummary:        function( data ) {
			if( data.summary ) {
				return data.summary;
			}
			return "";
		},
		getGaleTitleAndLink:       function( data ) {
			if( data.title && data.identifiers.length > 0 ) {
				return '<a target="_blank" href="' + $( data.identifiers ).eq( "0" ).attr( "uri" ) + '">' + data.title + '</a>';
			} else if( data.title ) {
				return data.title;
			}
			return "";
		},
		getGaleSource:             function( data ) {
			if( data.relation && data.bibliographicCitation ) {
				return data.relation + " - " + data.bibliographicCitation;
			} else if( data.relation ) {
				return data.relation;
			}
			return "";
		},
		getExtraGaleSummaries:          function( data ) {
			var response = "";
			if( data.descriptions ) {
				if( data.descriptions.length > 2 ) {
					for( var i = 2; i < data.descriptions.length; i++ ) {
						response += "<p>" + data.descriptions[i] + "</p>"
					}
				}
			}
			return response;
		},
		getDisplayExtraGaleSummaries:          function( data ) {
			if( data.descriptions && data.descriptions.length > 2 ) {
				return "";
			}
			return displayNone;
		},
		getGaleFirstSummary:       function( data ) {
			if( data.descriptions ) {
				return data.descriptions[0];
			}
			return "";
		},
		getGaleSecondSummary:      function( data ) {
			if( data.descriptions && data.descriptions.length > 1 ) {
				return data.descriptions[1];
			}
			return "";
		},
		getWorldBookTitleAndLink:   function( data ) {
			if( data.title && data.persistentLink ) {
				return '<a target="_blank" href="' + data.persistentLink + '">' + data.title + '</a>';
			} else if( data.title ) {
				return data.title;
			}
			return "";
		},
		getWorldBookCategory:         function( data ) {
			if( data.category ) {
				return data.category;
			}
			return "";
		},
		getWorldBookSummary:        function( data ) {
			if( data.summary ) {
				return data.summary;
			}
			return "";
		}
	}

})( jQuery );